import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MASTERS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_MASTER:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_MASTER:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_MASTER:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_MASTER:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
export const MastersTblDDL = (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MASTER_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
